export default __webpack_public_path__ + "assets/carousel-prev.3e811104.svg";